<script setup lang="ts">
/* eslint-disable vue/no-v-html */
import type { HTMLAttributes } from 'vue'
import { titleClasses } from '.'

const props = withDefaults(
  defineProps<{
    class?: HTMLAttributes['class']
    title: string
    titleAs?: string | Component
    description?: string
    subTitle?: string
    subTitleAs?: string | Component
    variantSize?: keyof typeof titleClasses
    viewTransition?: boolean
  }>(),
  {
    titleAs: undefined,
    class: undefined,
    description: undefined,
    subTitle: undefined,
    subTitleAs: undefined,
    variantSize: 'default',
    viewTransition: false
  }
)
</script>

<template>
  <div :class="cn('flex flex-col gap-2 lg:gap-3', props.class)">
    <component
      :is="props.subTitleAs ?? 'h3'"
      v-if="props.subTitle"
      class="font-semibold text-sm lg:text-lg text-primary"
      :style="
        props.viewTransition ? { viewTransitionName: 'section-subtitle' } : {}
      "
    >
      <span v-html="props.subTitle"></span>
    </component>
    <div class="flex flex-col gap-3">
      <component
        :is="props.titleAs ?? 'h2'"
        class="font-bold font-display lg:leading-tight"
        :class="[titleClasses[props.variantSize]]"
        :style="
          props.viewTransition ? { viewTransitionName: 'section-title' } : {}
        "
      >
        <span v-html="props.title"></span>
      </component>
      <p
        v-if="props.description"
        class="text-on-surface-variant lg:text-lg"
        :style="
          props.viewTransition
            ? {
                viewTransitionName: 'section-description'
              }
            : {}
        "
        v-html="props.description"
      />
    </div>
  </div>
</template>
